import React, { useState } from "react";
import "./Header.css";
import { FaReddit, FaBars } from "react-icons/fa";
import { IoSearch } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";

export default function Header({ handleToggleClick }) {
  const navigate = useNavigate();
  const [searchString, setSearchString] = useState("");
  let queryString = `/search/?q=${searchString}`;
  // const redditSearchString = `/search/.json?q=${queryParams}`;

  const handleChange = (e) => {
    setSearchString(e.target.value);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    navigate(queryString);
    setSearchString("");
  };

  return (
    <div className="header">
      <div className="logo">
        <Link to="/">
          <FaReddit className="reddit-logo" />
          <p>
            Mini<span>Reddit</span>
          </p>
        </Link>
      </div>
      <div className="search">
        <label>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Search here"
              value={searchString}
              onChange={handleChange}
            />
            <IoSearch className="ioSearch" style={{ color: "red" }} />
          </form>
        </label>
      </div>
      <div className="blank-space">
        <FaBars
          className="toggle"
          color="red"
          onClick={() => handleToggleClick()}
        />
      </div>
    </div>
  );
}
